import React from "react";
import { FiCheckCircle } from "react-icons/fi";

const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "numeric", month: "long", year: "numeric",
  });
};

const ReviewScreen = ({ submittedInfo, onEdit }) => (
  <div className="activation-page__card">
    <FiCheckCircle className="activation-page__icon activation-page__icon--success" />
    <h1 className="activation-page__title">Already Submitted</h1>
    <p className="activation-page__subtitle">
      We've already received your activation details.
    </p>

    <div className="activation-page__details">
      <div className="activation-page__detail-row">
        <span className="activation-page__detail-label">IMEI</span>
        <span className="activation-page__detail-value activation-page__detail-value--mono">
          {submittedInfo?.imei}
        </span>
      </div>
      <div className="activation-page__detail-row">
        <span className="activation-page__detail-label">EID</span>
        <span className="activation-page__detail-value activation-page__detail-value--mono">
          {submittedInfo?.eid}
        </span>
      </div>
      <div className="activation-page__detail-row">
        <span className="activation-page__detail-label">Activation Date</span>
        <span className="activation-page__detail-value">
          {formatDate(submittedInfo?.activationDate)}
        </span>
      </div>
    </div>

    <button className="activation-page__text-btn" onClick={onEdit}>
      Something wrong? Update your details →
    </button>
  </div>
);

export default ReviewScreen;
